// Root classname

export const ROOT = 'inline-flex h-56';
export const SM_ROOT = 'inline-flex h-32';

// Wrapper classnames

export const BASE_WRAPPER = 'inline-flex w-full z-1';

export const WRAPPER_DEFAULT = (dark?: boolean) =>
  `${BASE_WRAPPER} cursor-pointer${
    !dark ? ' border border-solid border-gray-main' : ''
  }`;
export const WRAPPER_CHECK = (dark?: boolean) =>
  `${BASE_WRAPPER} cursor-pointer${
    !dark ? ' border border-solid border-green-main' : ''
  }`;
export const WRAPPER_OPEN = (dark?: boolean) =>
  `${BASE_WRAPPER} z-4 cursor-pointer${!dark ? ' shadow-dropdown' : ''}`;
export const WRAPPER_DISABLED = () => `${BASE_WRAPPER} cursor-default`;

export const WRAPPER = {
  default: WRAPPER_DEFAULT,
  open: WRAPPER_OPEN,
  disabled: WRAPPER_DISABLED,
  check: WRAPPER_CHECK,
  sm: WRAPPER_DEFAULT,
};

// Main box classnames

export const BASE_BOX =
  'inline-flex flex-shrink-0 justify-between items-center w-full h-56 px-16';
export const SM_BOX =
  'inline-flex flex-shrink-0 justify-between items-center w-full h-32 px-16';

export const MAIN_BOX_DEFAULT = (dark?: boolean) =>
  `${BASE_BOX} relative ${
    dark
      ? 'bg-base-lighter-24 text-base-lighter'
      : 'bg-white text-base-main'
  }`;
export const MAIN_BOX_DISABLED = (dark?: boolean) =>
  `${BASE_BOX} relative ${
    dark
      ? 'bg-gray-dark-16 text-gray-dark'
      : 'bg-gray-lighter text-base-lighter'
  }`;

export const SECONDARY_BOX_SM = (dark?: boolean) =>
  `${SM_BOX} relative ${
    dark
      ? 'bg-base-lighter-24 text-base-lighter'
      : 'bg-white text-base-main'
  }`;

export const MAIN_BOX = {
  default: MAIN_BOX_DEFAULT,
  open: MAIN_BOX_DEFAULT,
  disabled: MAIN_BOX_DISABLED,
  sm: SECONDARY_BOX_SM,
};

// Option classnames

export const OPTION_WRAPPER =
  'inline-flex flex-col h-full w-full overflow-auto crehui-scrollable';

export const OPTION = `${BASE_BOX} text-base-main bg-white hover:text-primary-main hover:bg-gray-lighter`;
